import store from "../store";
export default class ImageContextBase {
  constructor(exam, componentName, browserName) {
    // name of the component to use for the image browser
    this.componentName = componentName;
    this.browserName = browserName;

    this.exam = exam;
    this.ptSrNo = exam.ptSrNo;
    this.exSrNo = exam.exSrNo;
    this.examMoment = exam.moment;

    this.playIntervalId = 0;
    this.playRate = "1";

    this.hasWebgl = store.getters.hasWebgl;
  }

  startupTask() {
    return Promise.resolve();
  }
  refreshImages(){
    return Promise.resolve();
  }
  clearContext() {
    this.pause();
    store.commit("clearImageQueue", "imageQueue");
  }
  updateViewSizes() { }

  pause() {
    if (this.playIntervalId) {
      clearInterval(this.playIntervalId);
      this.playIntervalId = 0;
    }
  }
  setPlayInterval(intervalId) {
    this.playIntervalId = intervalId;
  }
  setPlayRate(rate) {
    this.pause();
    this.playRate = rate;
  }
}

